var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60818",
    "data-name": "Group 60818",
    transform: "translate(-12669 -12605)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1377",
    "data-name": "Rectangle 1377",
    width: 100,
    height: 100,
    rx: 50,
    transform: "translate(12669 12605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_74263ff26820cd0d895968e3b55e8902",
    "data-name": "74263ff26820cd0d895968e3b55e8902",
    transform: "translate(12689.263 12628.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24347",
    "data-name": "Path 24347",
    d: "M60.75,170l7.645,2.028v-2.652l.624-.624h4.368v5.3h-4.68l-5.773-2.5Z",
    transform: "translate(-43.494 -121.54)",
    fill: "#cdbdb2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24348",
    "data-name": "Path 24348",
    d: "M0,4.056,7.489,2.028V4.68l.624.624h4.368V0H7.8L2.028,2.5Z",
    transform: "translate(42.218 52.514) rotate(180)",
    fill: "#cdbdb2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24349",
    "data-name": "Path 24349",
    d: "M88.937,150.405l-.624,5.148.78-.624h8.113l.936.624-.624-5.148-1.248-.78-6.24.156Z",
    transform: "translate(-63.412 -107.719)",
    fill: "#393939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24350",
    "data-name": "Path 24350",
    d: "M75.375,27l3.744,8.737,1.716,25.43H86.92l1.872-25.43L92.224,27Z",
    transform: "translate(-54.063 -19.105)",
    fill: "#f89c35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24351",
    "data-name": "Path 24351",
    d: "M4.931,83.993.563,96.63l10.921-.624H18.5v-5.46l-.312-11.233-1.56,1.248Z",
    transform: "translate(0 -56.909)",
    fill: "#f89d35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24352",
    "data-name": "Path 24352",
    d: "M46.125,101.25l12.793.312-1.4,6.553-6.085-1.56Z",
    transform: "translate(-32.925 -72.761)",
    fill: "#d87c30",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24353",
    "data-name": "Path 24353",
    d: "M46.125,101.813l5.3,4.992V111.8Z",
    transform: "translate(-32.925 -73.168)",
    fill: "#ea8d3a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24354",
    "data-name": "Path 24354",
    d: "M65.25,120.375l6.24,1.56,2.028,6.709-1.4.78-6.865-4.056Z",
    transform: "translate(-46.746 -86.582)",
    fill: "#f89d35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24355",
    "data-name": "Path 24355",
    d: "M62,138.375l-1.248,9.673,8.269-5.772Z",
    transform: "translate(-43.494 -99.59)",
    fill: "#eb8f35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24356",
    "data-name": "Path 24356",
    d: "M88.185,102.375l.78,13.261-2.34-6.787Z",
    transform: "translate(-62.192 -73.574)",
    fill: "#ea8e3a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24357",
    "data-name": "Path 24357",
    d: "M39.375,138.531l7.177-.156L45.3,148.048Z",
    transform: "translate(-28.047 -99.59)",
    fill: "#d87c30",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24358",
    "data-name": "Path 24358",
    d: "M4,152.667l13.261-4.212-5.928-9.517-10.765.78Z",
    transform: "translate(0 -99.996)",
    fill: "#eb8f35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24359",
    "data-name": "Path 24359",
    d: "M57.982,58.5l-6.708,5.616-5.149,6.24,12.793.468Z",
    transform: "translate(-32.925 -41.868)",
    fill: "#e8821e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24360",
    "data-name": "Path 24360",
    d: "M60.75,158.21l8.269-5.772-.624,4.992v2.808l-5.616-1.092Z",
    transform: "translate(-43.494 -109.752)",
    fill: "#dfcec3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24361",
    "data-name": "Path 24361",
    d: "M0,2.028,8.113,7.8,7.489,2.808V0L1.872,1.092Z",
    transform: "translate(42.218 50.486) rotate(180)",
    fill: "#dfcec3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24362",
    "data-name": "Path 24362",
    d: "M1.716,3.588,0,0,6.085,1.56Z",
    transform: "translate(24.277 35.197) rotate(180)",
    fill: "#393939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24363",
    "data-name": "Path 24363",
    d: "M12.375.563,33.593,16.632,30,7.9Z",
    transform: "translate(-8.536 0)",
    fill: "#e88f35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24364",
    "data-name": "Path 24364",
    d: "M5.058.563,2.25,9.143,3.81,18.5l-1.092.624,1.56,1.4L3.03,21.624l1.716,1.56-1.092.936,2.5,3.12,11.7-3.588q8.581-6.865,8.425-7.021T5.058.563Z",
    transform: "translate(-1.219)",
    fill: "#8e5a30",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60817",
    "data-name": "Group 60817",
    transform: "translate(58.911 52.671) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24365",
    "data-name": "Path 24365",
    d: "M4.368,12.637,0,0,10.921.624h7.02v5.46l-.312,11.233-1.56-1.248Z",
    transform: "translate(0 12.949)",
    fill: "#f89d35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24366",
    "data-name": "Path 24366",
    d: "M0,6.865l12.793-.312L11.389,0,5.3,1.56Z",
    transform: "translate(12.637 17.317)",
    fill: "#d87c30",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24367",
    "data-name": "Path 24367",
    d: "M0,9.985,5.3,4.992V0Z",
    transform: "translate(12.637 14.041)",
    fill: "#ea8d3a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24368",
    "data-name": "Path 24368",
    d: "M0,9.049l6.24-1.56L8.269.78,6.865,0,0,4.056Z",
    transform: "translate(17.941 9.829)",
    fill: "#f89d35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24369",
    "data-name": "Path 24369",
    d: "M1.248,9.673,0,0,8.113,5.616Z",
    transform: "translate(16.693 4.212)",
    fill: "#eb8f35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24370",
    "data-name": "Path 24370",
    d: "M1.56,13.261,2.34,0,0,6.787Z",
    transform: "translate(23.87 10.609)",
    fill: "#ea8e3a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24371",
    "data-name": "Path 24371",
    d: "M0,9.517l7.177.156L5.928,0Z",
    transform: "translate(10.765 4.212)",
    fill: "#d87c30",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24372",
    "data-name": "Path 24372",
    d: "M3.432,0,16.693,4.212l-5.928,9.517L0,12.949Z",
    transform: "translate(0)",
    fill: "#eb8f35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24373",
    "data-name": "Path 24373",
    d: "M11.857,12.325,5.149,6.709,0,.468,12.793,0Z",
    transform: "translate(12.637 23.714)",
    fill: "#e8821e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24374",
    "data-name": "Path 24374",
    d: "M1.716,0,0,3.588l6.085-1.56Z",
    transform: "translate(23.714 21.062) rotate(180)",
    fill: "#393939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24375",
    "data-name": "Path 24375",
    d: "M0,16.069,21.218,0,17.629,8.737Z",
    transform: "translate(3.276 36.039)",
    fill: "#e88f35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24376",
    "data-name": "Path 24376",
    d: "M2.808,26.678,0,18.1,1.56,8.737.468,8.113l1.56-1.4L.78,5.616,2.5,4.056,1.4,3.12,3.9,0,15.6,3.588q8.581,6.865,8.425,7.021T2.808,26.678Z",
    transform: "translate(0.468 25.43)",
    fill: "#8e5a30",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.573d5232c8eef9b207fd98203b897355.svg";
export { ForwardRef as ReactComponent };